import { render, staticRenderFns } from "./SettingsAdmin.vue?vue&type=template&id=a2e21672&"
import script from "./SettingsAdmin.vue?vue&type=script&lang=js&"
export * from "./SettingsAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports